export const OTP_CODE_LENGTH = 6;
